export const callBeginSession = (guid, history) => {
  return { type: "BEGIN_AUTH_SESSION", guid: guid, history: history };
};

export const callAuthGetLoans = () => {
  return { type: "AUTH_GET_LOANS" };
};

export const setAuthLoans = (loansResponse) => {
  return { type: "AUTH_SET_LOANS", loansResponse: loansResponse };
};

export const clearAuthLoans = (loans) => {
  return { type: "AUTH_CLEAR_LOANS", loans: loans };
};

export const setAuthAdditionalDetails = (details) => {
  return { type: "AUTH_SET_ADDITIONAL_DETAILS", selectedLoanAdditionalDetails: details };
};

export const callCreateAuthPaymentRecord = (loanNumber) => {
  return { type: "AUTH_CREATE_RECORD", loanNumber: loanNumber };
};

export const setAuthRecordCreated = () => {
  return { type: "AUTH_RECORD_CREATED" };
};

export const clearAuthRecord = () => {
  return { type: "AUTH_CLEAR_RECORD_CREATED" };
};

export const callAuthGetInternalAccounts = () => {
  return { type: "AUTH_GET_INTERNAL_ACCOUNTS" };
};

export const storeAuthInternalAccounts = (accounts) => {
  return { type: "AUTH_SET_INTERNAL_ACCOUNTS", internalAccounts: accounts };
};

export const callAuthSaveInternalInfo = (paymentDetails) => {
  return { type: "AUTH_SAVE_INTERNAL", paymentDetails: paymentDetails };
};

export const callStoreInternalResponse = (internalResponse) => {
  return { type: "AUTH_INTERNAL_SAVED", internalResponse: internalResponse };
};

export const callAuthSaveDebitInfo = (paymentDetails) => {
  return { type: "AUTH_SAVE_DEBIT", paymentDetails: paymentDetails };
};

export const callStoreDebitResponse = (debitResponse) => {
  return { type: "AUTH_DEBIT_SAVED", debitResponse: debitResponse };
};

export const callAuthSubmitDebitPayment = () => {
  return { type: "AUTH_SUBMIT_DEBIT" };
};

export const callAuthSubmitAchPayment = (paymentDetails) => {
  return { type: "AUTH_SUBMIT_ACH", paymentDetails: paymentDetails };
};

export const callAuthCancelFutureDatedPayment = (paymentId, setLoading, setError, onSuccess) => {
  return {
    type: "AUTH_CANCEL_FUTURE_DATED_PAYMENT",
    paymentId: paymentId,
    setLoading: setLoading,
    setError: setError,
    onSuccess: onSuccess,
  };
};

export const callAuthSubmitInternalPayment = (isCreditCard) => {
  return { type: "AUTH_SUBMIT_INTERNAL", isCreditCard: isCreditCard };
};

export const callStorePaymentResponse = (paymentResponse) => {
  return { type: "AUTH_PAYMENT_SUBMITTED", paymentResponse: paymentResponse };
};

export const callAuthCalcPostDate = (paymentDetails) => {
  return { type: "AUTH_CALC_POST_DATE", paymentDetails: paymentDetails };
};

export const storeAuthCalcPostDate = (achPostDate) => {
  return { type: "AUTH_SET_POST_DATE", achPostDate: achPostDate };
};

export const callAuthCalcPostDateV2 = (paymentDetails, cancel) => {
  return { type: "AUTH_VALIDATE_RECURRING", paymentDetails: paymentDetails, cancel: cancel };
};

export const callAuthCheckPayoff = (paymentDetails, AchOrDebit) => {
  paymentDetails.AchOrDebit = AchOrDebit;
  return { type: "AUTH_CHECK_PAYOFF", paymentDetails: paymentDetails };
};

export const callSaveAuthPayoffCheck = (checkResponse) => {
  return { type: "AUTH_PAYOFF_CHECKED", payoffCheck: checkResponse };
};

export const callAuthPostSkip = (debitDetails, skipDetails, hasSubmittedDebit) => {
  return {
    type: "AUTH_POST_SKIP",
    debitDetails: debitDetails,
    skipDetails: skipDetails,
    hasSubmittedDebit: hasSubmittedDebit,
  };
};

export const callAuthGetSkipInfo = (loanNumber, setSkipInfoCallback) => {
  return {
    type: "AUTH_GET_SKIP_INFO",
    loanNumber: loanNumber,
    setSkipInfoCallback: setSkipInfoCallback,
  };
};

export const callSaveSkipDenialReasons = (skipDenialReasons) => {
  return { type: "AUTH_SKIP_DENIAL_REASONS_LOADED", skipDenialReasons: skipDenialReasons };
};

export const callAuthClearSkipDenialReasons = () => {
  return { type: "CLEAR_AUTH_SKIP_DENIAL_REASONS" };
};

export const clearAuthRecurringValidation = () => {
  return { type: "AUTH_CLEAR_RECURRING_VALIDATION" };
};

export const callAuthCancelRecurring = (cancelDetails) => {
  return { type: "AUTH_CANCEL_RECURRING", cancelDetails: cancelDetails };
};

export const storeAuthCalcPostDateV2 = (recurringValidation) => {
  return { type: "AUTH_SET_RECURRING_VALIDATION", recurringValidation: recurringValidation };
};

export const callAuthGeneratePayoff = (accountHash) => {
  return { type: "AUTH_GENERATE_PAYOFF_LETTER", accountHash: accountHash };
};

export const callGetCardType = (cardNumber) => {
  return { type: "GET_CARD_TYPE", cardNumber: cardNumber };
};

export const setAuthError = () => {
  return { type: "SET_AUTH_ERROR" };
};

export const clearAuthError = () => {
  return { type: "CLEAR_AUTH_ERROR" };
};

export const resetAuthFlow = () => {
  return { type: "RESET_AUTH_FLOW" };
};

export const callAuthRefinanceRedirect = (accountHash) => {
  return { type: "AUTH_REFINANCE_REDIRECT", accountHash: accountHash };
};



// WEBPACK FOOTER //
// ./src/actions/authPayment.actions.js